import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {store} from "./app/store";
import {Provider} from "react-redux";
import * as serviceWorker from "./serviceWorker";
import {BrowserRouter} from "react-router-dom";
import {CssBaseline, ThemeProvider} from "@mui/material";
import {SnackbarProvider} from "notistack";
import {createTheme} from "@mui/material/styles";
import {SnackbarUtilsConfigurator} from "./components/SnackbarUtilsConfigurator";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers";
import "./i18n";

const theme = createTheme({
    palette: {
        primary: {
            main: "#034176", // DKV blue
        },
        secondary: {
            main: "#fc8c1c", // DKV orange
        },
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: 3,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: 0.2,
    },
    typography: {
        h1: {
            fontSize: "1.65rem",
            fontWeight: 500,
        },
        h2: {
            fontSize: "1.25rem",
            fontWeight: 500,
        },
        h5: {
            fontSize: "1.15rem",
            fontWeight: 400,
            margin: "14px 0px",
        },
        subtitle2: {
            color: "#000000",
            fontWeight: "500",
            fontSize: "1rem",
            lineHeight: "1.5",
            letterSpacing: "0.00938em",
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <BrowserRouter>
                        <CssBaseline />
                        <SnackbarProvider maxSnack={3} anchorOrigin={{horizontal: "right", vertical: "bottom"}}>
                            <SnackbarUtilsConfigurator />
                            <App />
                        </SnackbarProvider>
                    </BrowserRouter>
                </LocalizationProvider>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
